var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.64325 8.62584C8.08437 5.81226 12.3723 3.94271 14.5255 3.0357C20.6538 0.46276 21.942 0.0185104 22.7701 0C22.9542 0 23.359 0.037021 23.6351 0.259146C23.8559 0.444249 23.9111 0.684885 23.9479 0.869989C23.9848 1.05509 24.0216 1.44381 23.9848 1.73998C23.6535 5.25695 22.218 13.7902 21.4819 17.7144C21.1691 19.3804 20.5618 19.9357 19.9729 19.9912C18.6846 20.1023 17.7093 19.1397 16.4762 18.3253C14.5255 17.0481 13.4397 16.2521 11.5442 14.9934C9.3542 13.5496 10.7712 12.7537 12.0227 11.4579C12.3539 11.1247 18.0037 5.94183 18.1141 5.47907C18.1325 5.42354 18.1325 5.20142 18.0037 5.09035C17.8749 4.97929 17.6909 5.01631 17.5436 5.05333C17.3412 5.09035 14.2495 7.16352 8.2316 11.2543C7.34825 11.8652 6.55691 12.1613 5.83918 12.1428C5.04784 12.1243 3.53878 11.6986 2.39778 11.3283C1.01754 10.8841 -0.0866539 10.6435 0.00536217 9.86603C0.0605718 9.4588 0.612668 9.05157 1.64325 8.62584Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.f5d5556d.svg";
export { ForwardRef as ReactComponent };